import { render, staticRenderFns } from "./templateGenerate.vue?vue&type=template&id=9cd13310&scoped=true"
import script from "./templateGenerate.vue?vue&type=script&lang=js"
export * from "./templateGenerate.vue?vue&type=script&lang=js"
import style0 from "./templateGenerate.vue?vue&type=style&index=0&id=9cd13310&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd13310",
  null
  
)

export default component.exports